const BASE_URL = 'https://peladen.jogjaprov.go.id';
const API_URL = 'https://peladen.jogjaprov.go.id';
const BASE_URL_DEV = 'https://peladendev.jogjaprov.go.id';
const API_URL_DEV = 'https://peladendev.jogjaprov.go.id';
//
// const BASE_URL = 'http://localhost:3000';
// const API_URL = 'http://localhost:8080';

export function getAPIURL() {
  let origin = '';

  origin = 'https://peladen.jogjaprov.go.id/api';

  if (process.env.REACT_APP_STAGE === 'DEVELOPMENT') origin = 'http://localhost:8080/apidev';
  if (process.env.REACT_APP_STAGE === 'STAGING') origin = `${API_URL_DEV}/apidev`;
  if (process.env.REACT_APP_STAGE === 'PRODUCTION') origin = `${API_URL}/api`;

  return origin;
}

export function getBaseURL() {
  let origin = '';

  origin = 'https://peladen.jogjaprov.go.id';

  if (process.env.REACT_APP_STAGE === 'DEVELOPMENT') origin = 'http://localhost:3000';
  if (process.env.REACT_APP_STAGE === 'STAGING') origin = `${BASE_URL_DEV}`;
  if (process.env.REACT_APP_STAGE === 'PRODUCTION') origin = BASE_URL;
  return origin;
}

export function getSiteName() {
  let origin = 'https://peladen.jogjaprov.go.id';

  if (process.env.REACT_APP_STAGE === 'DEVELOPMENT') origin = 'PELADEN DEVELOPMENT';
  if (process.env.REACT_APP_STAGE === 'STAGING') origin = 'PELADEN STAGING';
  if (process.env.REACT_APP_STAGE === 'PRODUCTION') origin = 'PELADEN';

  return origin;
}
